import * as React from 'react'

export const DividerHorizontal = () => {
  return <div className="tw-min-h-[1px] tw-h-[1px] tw-w-full tw-bg-base-300"></div>
}
